import { LaravelResponse } from "@dgs/core";
import axios from "axios";
import { TravelDirection } from "../types/travelSegment";
import { TravelTemplateIndexResource, TravelTemplateSearchRequest } from "../types/travelTemplate";

const baseKey = ["travel-templates"];

const travelTemplateByDirectionKey = (direction: TravelDirection, request: TravelTemplateSearchRequest) => [
	...baseKey,
	direction,
	request,
];

export const travelTemplateService = {
	travelTemplateByDirectionKey,
	travelTemplateByDirection: (direction: TravelDirection, request: TravelTemplateSearchRequest) => {
		return axios.get<LaravelResponse<TravelTemplateIndexResource[]>>(`travel-templates/${direction}`, {
			params: request,
		});
	},
};
